import { render, staticRenderFns } from "./TeamIcon.vue?vue&type=template&id=7943126a&scoped=true"
import script from "./TeamIcon.vue?vue&type=script&lang=js"
export * from "./TeamIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7943126a",
  null
  
)

export default component.exports